import React from 'react';
import { Row } from 'antd';
import { useTranslation } from 'react-i18next';

import Dropdown from '../../../../common/Dropdown';

import { getAvailableSortFields } from '../../../helpers';
import viewSettingsActions from '../../../../../actions/viewSettingsActions';
import { SETTINGS_KEYS, VIEW_MODES } from '../../../../../configs/viewSettings';
import styles from '../config.less';

const SortField = (props) => {
  const { t } = useTranslation();

  if (!props.settings) {
    return null;
  }

  const value = props.settings.getIn([SETTINGS_KEYS.SORTING_RECORDS, SETTINGS_KEYS.FIELD_ID]);
  const currentSortType = props.settings.getIn([SETTINGS_KEYS.SORTING_RECORDS, SETTINGS_KEYS.SORT_TYPE]) || 1;
  const items = getAvailableSortFields(props.fields);

  const handleChange = (selectedItem) => {
    const fieldId = selectedItem ? selectedItem.key : '#id';
    viewSettingsActions.setSortingRecords({
      catalogId: props.catalogId,
      viewId: props.viewId,
      viewMode: VIEW_MODES.CALENDAR,
      sortField: fieldId,
      sortType: currentSortType,
    });
  };

  return items ? (
    <Row className={styles.controlRow}>
      <label className={styles.controlLabel}>{t('calendar.config.sortField')}</label>
      <Dropdown
        disabled={!items.length}
        items={[...items, { text: '№ записи', key: '#id' }]}
        value={value}
        autocomplete
        withButton
        multiselect={false}
        onSelectItems={([item]) => handleChange(item)}
      />
    </Row>
  ) : null;
};

export default SortField;
